import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Fingerprint, Cpu, Bot, Atom } from 'lucide-react';
interface PillarData {
  icon: React.ElementType;
  title: string;
  subtitle: string;
  description: string;
}
const pillars: PillarData[] = [{
  icon: Fingerprint,
  title: 'THE SELF',
  subtitle: 'The Mask You Were Given',
  description: "The ego is not who you are — it's the interface. Discover the code running your identity and how to see past it for the first time."
}, {
  icon: Cpu,
  title: 'THE SYSTEM',
  subtitle: 'The Rules Nobody Told You About',
  description: 'An invisible architecture of control shapes your reality daily. Understand how it works — and it loses its power over you instantly.'
}, {
  icon: Bot,
  title: 'THE ENTITIES',
  subtitle: 'Who Else Is Playing This Game',
  description: 'From ancient guardians to modern programmers — intelligences operate at levels most players never access. Learn to navigate them.'
}, {
  icon: Atom,
  title: 'THE AWAKENING',
  subtitle: 'How to Play Consciously',
  description: 'Practical tools for living awake inside a world that is designed to keep you asleep. The quantum leap from piece to player.'
}];
export function FourPillars() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-gradient-to-b from-black via-neutral-950 to-black" data-id="element-304">
      <div className="max-w-4xl mx-auto px-6" data-id="element-305">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-306">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase border rounded-full bg-teal-500/20 text-teal-400 border-teal-500/30 mb-6" data-id="element-307">
            The Architecture of the Game
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-308">
            The Four Pillars of the Framework
          </h2>
        </motion.div>

        {/* Pillar cards */}
        <div className="space-y-4" data-id="element-309">
          {pillars.map((pillar, i) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          x: -24
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + i * 0.08
        }} className="flex gap-5 p-6 md:p-8 rounded-2xl bg-neutral-900/50 border border-neutral-800/50 border-l-4 border-l-teal-500/60" data-id="element-310">
              <div className="flex-shrink-0 mt-1" data-id="element-311">
                <div className="w-12 h-12 rounded-xl bg-teal-500/10 flex items-center justify-center" data-id="element-312">
                  <pillar.icon className="w-6 h-6 text-teal-400" data-id="element-313" />
                </div>
              </div>
              <div data-id="element-314">
                <p className="text-teal-400 text-xs font-bold tracking-wider uppercase mb-1" data-id="element-315">
                  {pillar.title}
                </p>
                <h3 className="font-serif text-xl md:text-2xl text-white font-semibold mb-2" data-id="element-316">
                  {pillar.subtitle}
                </h3>
                <p className="text-neutral-400 text-sm md:text-base leading-relaxed" data-id="element-317">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}